module.exports = __webpack_public_path__ + "img/logo.4757ea72.png";